export const generateTime = (interval: number = 30) => {
	const times = []; // time array
	let startTime = 0; // start time
	const ap = ['AM', 'PM']; // AM-PM

	// loop from 0 to (24h * 60mins) - 1440
	for (let i = 0; startTime < 24 * 60; i++) {
		const hh = Math.floor(startTime / 60); // getting hours of day in 0-24 format
		const mm = startTime % 60; // getting minutes of the hour in 0-55 format

		const minutes = ('0' + mm).slice(-2);
		let hours = ('0' + (hh % 12)).slice(-2);
		const apCheck = ap[Math.floor(hh / 12)];

		// instead of having 00:00 AM lets have 12:00 AM so this check if hour is 12 or not
		if (hh % 12 === 0) {
			hours = '12';
		}

		// push time format to array 12:30 AM, 01:00 AM
		times[i] = `${hours}:${minutes} ${apCheck}`;

		// increase start time by interval passed
		startTime = startTime + interval;
	}

	return times;
};
